import { fireAuth } from './connect';
import { 
	signInWithEmailAndPassword,
	createUserWithEmailAndPassword,
	signOut
} from 'firebase/auth';

import CommonService from './common';
import UserService from './user';
import IUserModel from './models/user';

const commonService = new CommonService();
const userService = new UserService();

class AuthService {
	async singIn(email: string, password: string): Promise<string> {
		try {
			if (!email || !password) {
				return Promise.resolve(authErrors.emptyFields);
			}

			if (!commonService.isEmail(email)) {
				return Promise.resolve(authErrors.invalidEmail);
			}

			const login = await signInWithEmailAndPassword(fireAuth, email, password);
			if (!login) {
				return Promise.resolve(authErrors.systemError);
			}

			const { user } = login;
			const verifyCustomer = await userService.verifyCustomer(user.uid);
			if (verifyCustomer === 'OK') {
				await fireAuth.signOut();
				return authErrors.invalidUser;
			}

			return Promise.resolve('OK');
		} catch ({ code }) {
			// console.log(code);
			if (code === 'auth/invalid-email') {
				return Promise.resolve(authErrors.invalidEmail);
			}
			if (code === 'auth/wrong-password') {
				return Promise.resolve(authErrors.loginWrongCredential);
			}
			if (code === 'auth/user-not-found') {
				return Promise.resolve(authErrors.loginWrongCredential);
			}
			return Promise.resolve(authErrors.systemError);
		}
	}

	async singUp(name: string, email: string, password: string): Promise<string> {
		try {
			if (!name || !email || !password) {
				return Promise.resolve(authErrors.emptyFields);
			}

			if (!commonService.isEmail(email)) {
				return Promise.resolve(authErrors.invalidEmail);
			}

			if (!commonService.isValidPassword(password)) {
				return Promise.resolve(authErrors.invalidPassword);
			}

			const create = await createUserWithEmailAndPassword(fireAuth, email, password);
			if (!create) {
				return Promise.resolve(authErrors.systemError);
			}
			const {
				user: { uid }
			} = create;

			const userData: IUserModel = {
				name,
				uid,
				email,
				picture: '',
				status: false,
				roll: 0,
				pushTokens: []
			};
			await userService.create(uid, userData);
			return Promise.resolve('OK');
		} catch ({ code }) {
			if (code === 'auth/email-already-in-use') {
				return Promise.resolve(authErrors.emailUnavailable);
			}

			if (code === 'auth/invalid-email') {
				return Promise.resolve(authErrors.invalidEmail);
			}
			return Promise.resolve(authErrors.systemError);
		}
	}

	logout(){
		signOut(fireAuth);
	}
}

const authErrors = {
	emptyFields: 'empty',
	invalidEmail: 'invalid email',
	invalidPassword: 'invalid password',
	loginWrongCredential: 'login wrong crendentials',
	emailUnavailable: 'email unavailable',
	invalidUser: 'invalid user',
	systemError: 'system error'
};

export default AuthService;
export { authErrors };
